import processStream from './stream-channel'

class Video {
	constructor() {
		this.stream()
		// this.stickyPlayer()
	}

	stream() {
		try {
			if (document.querySelector('#player-element')) {
				processStream('player-element', false, false, true)
			}
		} catch (error) {
			console.log('Video.stream', { message: error.message })
		}
	}

	stickyPlayer() {
		try {
			let player_wrapper = document.querySelector('.player-wrapper')

			if (player_wrapper) {
				let fixed_player = document.querySelector('.fixed-player')
				let bottom_player = document.querySelector('.bottom-player')
				let marquee_wrap = document.querySelector('.marquee-wrap')

				if (marquee_wrap) {
					marquee_wrap.remove()
				}
				if (bottom_player) {
					let mt = fixed_player?.clientHeight + 10 /* menu */
					Object.assign(bottom_player.style, {
						height: mt + 'px',
					})
				}
				window.addEventListener('resize', function (params) {
					let fixed_player = document.querySelector('.fixed-player')
					if (window.innerHeight < window.innerWidth) {
						document.querySelector('header')?.classList.remove('fixed')
						fixed_player.classList.remove('fixed')
						let bottom_player = document.querySelector('.bottom-player')
						Object.assign(bottom_player.style, {
							height: '0',
						})
						document.querySelector('body')?.classList.remove('pt-12')
					} else {
						document.querySelector('header')?.classList.add('fixed')
						document.querySelector('body')?.classList.add('pt-12')
						fixed_player.classList.add('fixed')
						let bottom_player = document.querySelector('.bottom-player')
						if (bottom_player) {
							let mt = fixed_player.clientHeight + 10 /* menu */
							Object.assign(bottom_player.style, {
								height: mt + 'px',
							})
						}
					}
				})
			}
		} catch (error) {
			console.log('App.stickyPlayer', { message: error.message })
		}
	}
}

export default window.addEventListener('DOMContentLoaded', function (evt) {
	new Video()
})
